import Categories from "./Categories"
import Slides from "./Slides"

const InsideSection: React.FC = () => {
  return (
    <div
      className="w-full max-w-screen pt-28 h-full mx-auto items-center justify-center bg-cover bg-center bg-no-repeat relative"
      style={{ backgroundImage: "url('/background-img.jpg')" }}
    >
      <div className="max-w-4xl mx-auto px-8 text-center flex flex-col items-center justify-center">
        <h2 className="text-4xl md:text-5xl font-bold text-primary mb-8 leading-tight">
          Không gian tĩnh lặng nuôi dưỡng tâm hồn
        </h2>
        <div className="text-lg md:text-xl text-primary leading-relaxed space-y-4  mx-auto">
          <p className="max-w-[750px] w-full mx-auto text-justify md:text-center">
            Giữa nhịp phố thị vội vã, Thiền Trúc mở ra một khoảng dừng yên ả. Ở
            đây, mỗi hơi thở như chậm lại, để người thưởng thức cảm nhận được
            tiếng gió qua tán lá, ánh sáng nhẹ rơi trên vách tường đất, và hương
            vị thuần khiết của món chay.
          </p>
          <p className="max-w-[760px] w-full mx-auto text-justify md:text-center">
            Không gian không chỉ để dùng bữa mà để trở về với chính mình, như
            một khoảng thiền giữa đời thường.
          </p>
        </div>
      </div>

      <Slides />
      <Categories />
    </div>
  )
}

export default InsideSection
